import React, {useState} from 'react'
import styled from 'styled-components'

import {useFlags, useFlagsLoaded} from '@/flags'
import {tokens, colors} from '@/theme'

const BottomRightCard = styled.div`
    display: grid;
    gap: ${tokens.spacing8};
    align-items: center;
    padding: ${tokens.spacing10};
    background-color: ${colors.background.default};
    border-radius: ${tokens.arc4};
    box-shadow: ${tokens.shadowElevate};
    position: fixed;
    bottom: ${tokens.spacing10};
    right: ${tokens.spacing10};
    z-index: 1000;
`

const CloseButton = styled.button`
    position: absolute;
    top: ${tokens.spacing4};
    right: ${tokens.spacing4};
    background: none;
    border: none;
    cursor: pointer;
`

export const DebugComponent = () => {
    const [isVisible, setIsVisible] = useState(true)
    const isLoaded = useFlagsLoaded()
    const flags = useFlags()
    const environment = process.env.GATSBY_ACTIVE_ENV === 'production' ? 'production' : 'staging'
    const clientId = process.env.GATSBY_LAUNCH_DARKLY_CLIENT_ID!

    const isTestComponentEnabled = Boolean(flags.testFlag)

    if (!isTestComponentEnabled || !isVisible) {
        return null
    }

    const debugInfo = {
        environment,
        clientId,
        isLoaded,
        flags,
    }

    return (
        <BottomRightCard>
            <CloseButton onClick={() => setIsVisible(false)}>✖</CloseButton>
            <h4>LaunchDarkly Debug Info</h4>
            <pre>{JSON.stringify(debugInfo, null, 2)}</pre>
        </BottomRightCard>
    )
}
